module.exports = __webpack_public_path__ + "img/4.e14b3e55.svg";